import React from "react";
import { Grid, Typography, Stack, Box, Button } from "@mui/material";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import { useNavigate } from "react-router-dom";
import useBookmarks from "../hooks/useBookmarks";

function Bookmarks() {
  const navigate = useNavigate();
  const { bookmarks, remove: handleRemoveBookmark } = useBookmarks();

  const handleProductClick = (productId) => {
    navigate(`/products/${productId}`);
  };

  return (
    <Box sx={{ maxWidth: "1440px", margin: "0 auto" }}>
      <Box sx={{ padding: { xs: "16px", md: "40px 60px" } }}>
        <Typography
          variant="h1"
          sx={{
            fontSize: "40px",
            fontWeight: 500,
            lineHeight: "43px",
            color: "#1f2229",
            fontFamily: "Avenir Book",
            textAlign: "start",
            marginBottom: "40px",
          }}>
          Favorites
        </Typography>

        {bookmarks.length > 0 ? (
          <Grid container spacing={2}>
            {bookmarks.map((product, index) => (
              <Grid
                item
                key={product.post_id || index}
                xs={12}
                sm={6}
                md={3}
                sx={{ marginBottom: "40px" }}>
                <div className="product-main">
                  <div
                    className="bookmark-icon"
                    onClick={() => handleRemoveBookmark(product)}
                    style={{
                      position: "absolute",
                      top: "20px",
                      right: "20px",
                      zIndex: 10,
                      cursor: "pointer",
                      backgroundColor: "#323232",
                      borderRadius: "50%",
                      padding: "6px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      transition: "transform 0.2s ease",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "scale(1.1)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "scale(1)")
                    }
                    title="Remove from favorites">
                    <BookmarkBorderIcon sx={{ color: "#fff", fontSize: 24 }} />
                  </div>

                  <Box
                    sx={{
                      cursor: "pointer",
                      width: "100%",
                      overflow: "hidden",
                      borderRadius: "0px",
                      mb: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      position: "relative",
                      "&:hover .overlay": { opacity: 1 },
                    }}
                    onClick={() => handleProductClick(product?.post_id)}>
                    <img
                      width="100%"
                      src={product?.featured_image}
                      alt={product?.name || `Product ${index}`}
                      decoding="async"
                      loading="lazy"
                    />
                    <Box
                      className="overlay"
                      sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.2)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        opacity: 0,
                        transition: "opacity 0.3s ease",
                      }}>
                      <Button
                        variant="contained"
                        sx={{
                          backgroundColor: "#333333",
                          color: "#fff",
                          padding: "12px 20px",
                          borderRadius: "0px",
                          fontSize: "14px",
                          fontWeight: 400,
                          textTransform: "none",
                          "&:hover": { backgroundColor: "#333" },
                        }}>
                        View Details
                      </Button>
                    </Box>
                  </Box>
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: "20px",
                      lineHeight: "27px",
                      color: "#000000",
                      letterSpacing: "-2%",
                      fontWeight: 500,
                      fontFamily: "Avenir Book",
                      cursor: "pointer",
                    }}
                    onClick={() => handleProductClick(product?.post_id)}>
                    {product?.name}
                  </Typography>
                </div>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Stack
            justifyContent="center"
            alignItems="center"
            sx={{ minHeight: "300px" }}>
            <Typography
              sx={{
                fontSize: "18px",
                color: "#53565a",
                textAlign: "center",
                fontFamily: "Avenir Book",
              }}>
              No Favorites yet.
            </Typography>
          </Stack>
        )}
      </Box>
    </Box>
  );
}

export default Bookmarks;
